import { HStack, Heading, Stack, VStack, useColorModeValue, Image } from '@chakra-ui/react'
import { SplitPayForm } from '../components'
import splitSvg from '../assets/splitpay.svg'

const SplitPay = () => {
  return (
    <VStack minH={{ base: '80vh', md: '74vh' }} wrap={'wrap'} align={'center'} justify={'center'}>
      <HStack minH={{ base: '80vh', md: '74vh' }} wrap={'wrap'} align={'center'} justify={'center'}>
        <Image src={splitSvg} boxSize={{ base: '170px', md: 'sm' }}></Image>
        <Stack
          spacing={'4'}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '6', md: '8' }}
          my={{ base: '6', md: '12' }}
        >
          <Heading
            fontSize={{ base: '2xl', md: '4xl' }}
            color={'brand.500'}
            alignSelf={'center'}
            lineHeight={0.8}
            mb={{ base: 0, md: 4 }}
          >
            Split_Pay ✂️
          </Heading>
          <SplitPayForm />
        </Stack>
      </HStack>
    </VStack>
  )
}
export default SplitPay
